import { useMutation } from '@tanstack/vue-query'
import { logout } from '@/features/auth/api/auth'
import { useAuthStore } from '@/stores/auth'

/** Revokes the token server-side on a best-effort basis; the local session always ends. */
export function useLogout() {
  const auth = useAuthStore()

  return useMutation({
    mutationFn: async () => {
      try {
        await logout()
      } finally {
        auth.logout()
      }
    },
  })
}
